export const getOnboardingStatus = (axiosInstance) => {
    return axiosInstance.get('v2/player/onboarding');
};

export const getStudentInfo = (axiosInstance, playerId) => {
    return axiosInstance.get(`v1/player/${playerId}/studentinfo`);
};

export const optCollegeRecruitment = (axiosInstance, values) => {
    return axiosInstance.put('v2/player/collegerecruiting', values);
};

export const updateCollegeRecruitmentDetails = (axiosInstance, values) => {
    return axiosInstance.put('v1/player/studentinfo', values);
};

export const updatePBRRange = (axiosInstance, values) => {
    return axiosInstance.post('v1/member/pbrRange', values);
};

export const postUtrRangeSurvey = (axiosInstance, values) => {
    return axiosInstance.post('v1/member/utr-range', values);
};

export const skipUtrRangeSurvey = (axiosInstance) => {
    return axiosInstance.post('v1/member/utr-range/skip');
};

export const postAustraliaOnboarding = (axiosInstance, values) => {
    return axiosInstance.post('v2/player/australiaonboarding', values);
};

export const postTennisConnectId = (axiosInstance, values) => {
    return axiosInstance.post('v2/player/tennisconnect', values);
};

export const postPickleballRangeSurveyV2 = (axiosInstance, values) => {
    return axiosInstance.post('v1/member/pkbr-survey', values);
};

export const updatePBRRangeV2 = (axiosInstance, values) => {
    return axiosInstance.post('v1/member/cbr-survey', values);
};

export const postUtrRangeSurveyV2 = (axiosInstance, values) => {
    return axiosInstance.post('v1/member/utr-survey', values);
};

// NUO v2

export const getOnboardingStatusV2 = (axiosInstance) => {
    return axiosInstance.get('v2/onboarding');
};

export const postAdditionalInfoV2 = (axiosInstance, values) => {
    return axiosInstance.post('v2/onboarding/additional-info', values);
};
export const postMemberTypeV2 = (axiosInstance, values) => {
    return axiosInstance.post('v2/onboarding/member-type', values);
};
export const postSportTypeV2 = (axiosInstance, values) => {
    return axiosInstance.post('v2/onboarding/sport-type', values);
};
export const createPlayerV2 = (axiosInstance, values) => {
    return axiosInstance.post('v2/onboarding/create-player', values);
};
export const claimPlayerV2 = (axiosInstance, values) => {
    return axiosInstance.post('v2/onboarding/claim-player', values);
};
export const colorballPlayerV2 = (axiosInstance, values) => {
    return axiosInstance.post('v2/onboarding/colorball-player', values);
};
export const colorballSurveyV2 = (axiosInstance, values) => {
    return axiosInstance.post('v2/onboarding/cbr-survey', values);
};
export const tennisSurveyV2 = (axiosInstance, values) => {
    return axiosInstance.post('v2/onboarding/utr-survey', values);
};
export const pickleballSurveyV2 = (axiosInstance, values) => {
    return axiosInstance.post('v2/onboarding/pkbr-survey', values);
};
export const postNCSAReg = (axiosInstance, values) => {
    return axiosInstance.post('v2/onboarding/ncsa-registration', values);
};
export const skipNCSAReg = (axiosInstance, values) => {
    return axiosInstance.post('v2/onboarding/ncsa-registration/skip', values);
};
export const skipTennisSurveyV2 = (axiosInstance, values) => {
    return axiosInstance.post('v2/onboarding/utr-survey/skip', values);
};
export const skipPickleballSurveyV2 = (axiosInstance, values) => {
    return axiosInstance.post('v2/onboarding/pkbr-survey/skip', values);
};
export const postTennisAustraliaV2 = (axiosInstance, values) => {
    return axiosInstance.post('v2/onboarding/australia-onboarding', values);
};
export const skipTennisAustraliaV2 = (axiosInstance, values) => {
    return axiosInstance.post('v2/onboarding/australia-onboarding/skip', values);
};
